export enum UserRolesEnum {
    SuperAdmin = "SuperAdmin",
    Admin = "Admin",
    ResultManager = "ResultManager",
    DealershipManager = "DealershipManager",
    DealershipEmployee = "DealershipEmployee",
}